<template>
    <div v-if="hasJobs" class="mr-3 uncomp-jobs">
        <v-tooltip text="Uncompleted Jobs" location="bottom">
            <template v-slot:activator="{ props }">
                <v-badge @click="showJobs" :content="jobs.length">
                    <v-icon icon="mdi-file-document-alert-outline" v-bind="props" class="text-yellow-lighten-3"></v-icon>
                </v-badge>
            </template>
        </v-tooltip>
        <v-dialog v-model="jobModal"
                  persistent
                  :scrim="false">
            <v-card>
                <v-toolbar dark
                           color="primary">
                    <v-spacer></v-spacer>
                    <v-btn icon
                           dark
                           @click="jobModal = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <p>Below is a list of jobs completed over 2 days ago that require completing and invoicing.</p>
                    <v-table>
                        <thead>
                            <tr>
                                <th class="text-left">Job</th>
                                <th class="text-left">Customer</th>
                                <th class="text-left">Customer Number</th>
                                <th class="text-left">Status</th>
                                <th class="text-left">$</th>
                                <th class="text-left">Date Completed</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="job in jobs" :key="job.id">
                                <td> <router-link :to="'/'+$constants.entities.Job.ROUTE+job.id" @click="jobModal=false">{{ job.name }}</router-link></td>
                                <td>{{ job.customerName }}</td>
                                <td>{{ job.customerNumber }}</td>
                                <td><type-chip :type="job.status" entity="Job" :object="job"></type-chip></td>
                                <td>{{ numberWithCommas(job.jobSubTotal, 2) }}</td>
                                <td><span v-if="job.dateCompleted">{{ $dayjs(job.dateCompleted).format("DD/MM/YYYY") }}</span></td>
                            </tr>
                        </tbody>
                    </v-table>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<style scoped>
    .uncomp-jobs {
        cursor:pointer;
    }
</style>
<script>
    import { numberWithCommas } from "../mixins/numberMixins";
    import { mapActions } from "vuex";
    function initialState() {
        return {
            saving: false,
            loading: false,
            jobs: null,
            jobModal: false,
            refreshInterval: null
        };
    }
    export default {
        name: "UncompletedJobs",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.loadData();
            this.refreshInterval = setInterval(() => {
                this.loadData();
            }, 600000);
        },
        beforeUnmount: function () {
            // Clean up the interval when component is destroyed
            if (this.refreshInterval) {
                clearInterval(this.refreshInterval);
            }
        },
        props: {
            props: Object,
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack"
            ]),
            numberWithCommas,
            showJobs() {
                this.jobModal = true;
            },
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            loadData() {
                this.loading = true;
                this.$api.get('dashboard/uncompletedjobs')
                    .then(res => {
                        this.jobs = res.data;
                        this.loading = false;
                    }).catch(error => {
                        this.loading = false;
                        this.showErrorSnack("Whoops. We ran into an error.");
                    });
            }
        },
        computed: {
            hasJobs() {
                return this.jobs && this.jobs.length > 0;
            }
        }
    };
</script>